.root {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 32px;
  text-align: center;
}

.title {
  margin: 0 0 8px;
}

.body {
  color: var(--text-secondary);
}
